<template>
    <div class="home-page">
        <leftnav class="fl"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <!-- <govheader></govheader> -->
            <div class="index_left_centerpage">
                <div class="whitebox height-90vh ">
                    <div class="search-banner">
                        <h1 class="text-center title">大数据精准招商专业平台</h1>
                        <div class="search-input-box">
                            <div class="search-type">
                                <span class="type-text" :class="searchtype == 1 ? 'active' : ''"
                                    @click="searchtype = 1">搜目标企业</span>
                                <span class="type-text" :class="searchtype == 2 ? 'active' : ''"
                                    @click="searchtype = 2">搜产业链</span>
                                <span class="type-text" :class="searchtype == 3 ? 'active' : ''"
                                    @click="searchtype = 3">搜研究报告</span>
                            </div>
                            <input class="search-input" :placeholder="placeholder" v-model="kw"
                                @keyup.enter="searchkwfun" />
                            <button class="search-btn" @click="searchkwfun">搜索</button>
                        </div>
                        <div class="close-btn" @click="routerself('/totalEnterprises')">
                            <i class="iconfont el-icon-close"> </i>
                        </div>
                        <!-- <ul class="menu">
                            <li @click="logout()">退出登录</li>
                            <li @click="routerself('/userFocus')">关注领域</li>
                        </ul> -->
                    </div>

                    <div class="content-box">
                        <div class="w95mg content">
                            <div class="content-item item1" style="width: 70%;">
                                <div class="con-max-height">
                                    <div class="content-item-title">本市招商动态</div>
                                    <div class="land-ecahrt-title w95mg ">
                                        <span class="title fl" @click="city_invest_land_type = 1"
                                            :class="city_invest_land_type == 1 ? 'current' : ''">招引上市公司动态</span>
                                        <span class="title fl" @click="city_invest_land_type = 3"
                                            :class="city_invest_land_type == 3 ? 'current' : ''">招引拿地项目动态</span>
                                        <span class="fr mt-1 mr curp mr-1"
                                            @click="routerblank('/invest-project-trend?type=' + city_invest_land_type)">查看更多
                                            > </span>
                                    </div>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="city_invest_land_type == 1">
                                        <tr>
                                            <th>公司名称</th>
                                            <th>项目名称</th>
                                            <th>投资来源地</th>
                                            <th>投资金额</th>
                                            <th>日期</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in enterpriseList_city_invest"
                                            v-show="ind < 5">
                                            <td>
                                                <span class="fwb curp" v-if="list.stockCode != ''"
                                                    @click="routerlinkid('/enterprises', list.stockCode)">{{
                                                    list.shortName }}</span>
                                                <span v-if="list.stockCode == ''">{{ list.shortName }}</span>
                                            </td>
                                            <td><span :class="(list.url && list.url != '') ? 'curp' : ''"
                                                    @click="openProjectLink(list.url)">{{ list.projectName }}</span>
                                            </td>
                                            <td>{{ list.sourceArea }}</td>
                                            <td>{{ list.money }}{{ list.moneyUnit }}</td>
                                            <td>{{ list.time }}</td>
                                        </tr>
                                    </table>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="city_invest_land_type == 3">
                                        <tr>
                                            <th>项目名称</th>
                                            <th>总面积(亩)</th>
                                            <th>投资主体</th>
                                            <th>投资来源地</th>
                                            <th>日期</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in enterpriseList_city_land" v-show="ind < 5">
                                            <td>
                                                <span :class="(list.url && list.url != '') ? 'curp' : ''"
                                                    @click="openProjectLink(list.url)">{{ list.projectName }}</span>
                                            </td>
                                            <td>{{ list.size }}{{ list.sizeUnit }}</td>
                                            <td>
                                                <span class="curp" v-if="list.sourceStockCode != ''"
                                                    @click="routerlinkid('/enterprises', list.sourceStockCode)">{{
                                                    list.sourceEnterprise }}</span>
                                                <span v-if="list.sourceStockCode == ''">{{ list.sourceEnterprise
                                                    }}</span>
                                            </td>
                                            <td>{{ list.sourceArea }}</td>
                                            <td>{{ list.time }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="con-max-height">
                                    <div class="content-item-title">本省招商动态</div>
                                    <div class="land-ecahrt-title w95mg ">
                                        <span class="title fl" @click="province_invest_land_type = 2"
                                            :class="province_invest_land_type == 2 ? 'current' : ''">招引上市公司动态</span>
                                        <span class="title fl" @click="province_invest_land_type = 4"
                                            :class="province_invest_land_type == 4 ? 'current' : ''">招引拿地项目动态</span>
                                        <span class="fr mt-1 mr curp mr-1"
                                            @click="routerblank('/invest-project-trend?type=' + province_invest_land_type)">查看更多
                                            > </span>
                                    </div>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="province_invest_land_type == 2">
                                        <tr>
                                            <th>公司名称</th>
                                            <th>项目名称</th>
                                            <th>投资来源地</th>
                                            <th>投资金额</th>
                                            <th>日期</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in enterpriseList_province_invest"
                                            v-show="ind < 5">
                                            <td>
                                                <span class="fwb curp" v-if="list.stockCode != ''"
                                                    @click="routerlinkid('/enterprises', list.stockCode)">{{
                                                    list.shortName }}</span>
                                                <span v-if="list.stockCode == ''">{{ list.shortName }}</span>
                                            </td>
                                            <td><span :class="(list.url && list.url != '') ? 'curp' : ''"
                                                    @click="openProjectLink(list.url)">{{ list.projectName }}</span>
                                            </td>
                                            <td>{{ list.sourceArea }}</td>
                                            <td>{{ list.money }}{{ list.moneyUnit }}</td>
                                            <td>{{ list.time }}</td>
                                        </tr>
                                    </table>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-if="province_invest_land_type == 4">
                                        <tr>
                                            <th>项目名称</th>
                                            <th>总面积(亩)</th>
                                            <th>投资主体</th>
                                            <th>投资来源地</th>
                                            <th>日期</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in enterpriseList_province_land"
                                            v-show="ind < 5">
                                            <td>
                                                <span :class="(list.url && list.url != '') ? 'curp' : ''"
                                                    @click="openProjectLink(list.url)">{{ list.projectName }}</span>
                                            </td>
                                            <td>{{ list.size }}{{ list.sizeUnit }}</td>
                                            <td>
                                                <span class="curp" v-if="list.sourceStockCode != ''"
                                                    @click="routerlinkid('/enterprises', list.sourceStockCode)">{{
                                                    list.sourceEnterprise }}</span>
                                                <span v-if="list.sourceStockCode == ''">{{ list.sourceEnterprise
                                                    }}</span>
                                            </td>
                                            <td>{{ list.sourceArea }}</td>
                                            <td>{{ list.time }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <div class="content-item">
                                <div>
                                    <div class="content-item-title">重点产业链推荐</div>
                                    <ul class="lian">
                                        <li @click="handlerRouter('chain', list)" class="curp" :key="ind"
                                            v-for="(list, ind) in chainlist" v-show="ind < 18">
                                            {{ list.chainName }}</li>
                                    </ul>
                                </div>
                                <div>
                                    <div class="content-item-title">重点行业报告推荐</div>
                                    <ul class="rpt">
                                        <li @click="handlerRouter('rpt', list)" :key="ind"
                                            v-for="(list, ind) in reportList" v-show="ind < 7">{{ list.title }} <span
                                                class="fr mr-1"> > </span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="w95mg">
                            <div class="content-item" style="width: 100%;">
                                <div>
                                    <div class="content-item-title">招大引强目标企业推荐</div>
                                    <div class="land-ecahrt-title w95mg ">
                                        <span class="title fl" @click="handler_enterprise_type(9, 'lm')"
                                            :class="lm_enterprise_type == 9 ? 'current' : ''">上市公司</span>
                                        <span class="title fl" @click="handler_enterprise_type(0, 'lm')"
                                            :class="lm_enterprise_type == 0 ? 'current' : ''">央企</span>
                                        <span class="fr mt-1 mr curp mr-1" v-show="lm_enterprise_type == 9"
                                            @click="routerblank('/enterpriseList?type=9&Pt=1')">查看更多 > </span>
                                        <span class="fr mt-1 mr curp mr-1" v-show="lm_enterprise_type == 0"
                                            @click="routerblank('/totalEnterprises?type=0&tag=A020131')">查看更多 > </span>
                                    </div>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="lm_enterprise_type == 9">
                                        <tr>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in ss_enterprise_list" v-show="ind < 5">
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" v-for="(item, i) in list.notionlist" :key="i"
                                                    v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" v-for="(item, i) in list.taglist"
                                                    :key="item.id + '' + i" v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="lm_enterprise_type == 0">
                                        <tr>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in yq_enterprise_list" v-show="ind < 5">
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" v-for="(item, i) in list.notionlist" :key="i"
                                                    v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" v-for="(item, i) in list.taglist"
                                                    :key="item.id + '' + i" v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div>
                                    <div class="content-item-title">招新引优目标企业推荐</div>
                                    <div class="land-ecahrt-title w95mg ">
                                        <span class=" title fl" @click="handler_enterprise_type(2, 'sm')"
                                            :class="sm_enterprise_type == 2 ? 'current' : ''">创投企业</span>
                                        <span class="title fl" @click="handler_enterprise_type(0, 'sm')"
                                            :class="sm_enterprise_type == 0 ? 'current' : ''">专精特新企业</span>
                                        <span class="fr mt-1 mr curp mr-1" v-show="sm_enterprise_type == 2"
                                            @click="routerblank('/enterpriseList?type=2&Pt=2')">查看更多 > </span>
                                        <span class="fr mt-1 mr curp mr-1" v-show="sm_enterprise_type == 0"
                                            @click="routerblank('/totalEnterprises?type=0&tag=A080101')">查看更多 > </span>
                                    </div>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="sm_enterprise_type == 2">
                                        <tr>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in cx_enterprise_list" v-show="ind < 5">
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" v-for="(item, i) in list.notionlist" :key="i"
                                                    v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" v-for="(item, i) in list.taglist"
                                                    :key="item.id + '' + i" v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="sm_enterprise_type == 0">
                                        <tr>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in zj_enterprise_list" v-show="ind < 5">
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" v-for="(item, i) in list.notionlist" :key="i"
                                                    v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" v-for="(item, i) in list.taglist"
                                                    :key="item.id + '' + i" v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'home-page',
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },

    data() {
        return {
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            kw: '',
            searchtype: 1,
            placeholder: '请输入企业名称',
            enterpriseList: [],
            reportList: [],
            chainlist: [],
            ajaxurlData: { land: "", invest: "" },
            land_invest_type: '',
            ajaxurl: '',
            cur_list: {},
            page_list: [
                {
                    id: 1,
                    type: 'city',
                    title: "上市公司在本市投资项目",
                    itemcode: "P-SSGSZBCTZ",
                    ajax_type: 'invest',
                    children: [
                        { label: "外地企业在本市已投项目", value: 997, sourceType: "sourceProvince", type: 'invest' },
                    ]
                },
                {
                    id: 2,
                    type: 'province',
                    title: "上市公司在本省投资项目",
                    ajax_type: 'invest',
                    itemcode: "P-SSGSZBSTZ",
                    children: [{ label: "省外上市公司在本省投资项目", value: 998, sourceType: 'sourceProvince', type: 'invest' },]
                },
                {
                    id: 3,
                    type: 'city',
                    title: "企业在本市拿地投资项目",
                    itemcode: "P-QYZBCNDTZ",
                    ajax_type: 'land',
                    children: [{ label: "外地企业在本市已投项目", value: 997, sourceType: "sourceProvince", type: 'land' },]
                },
                {
                    id: 4,
                    type: 'province',
                    title: "企业在本省拿地投资项目",
                    itemcode: "P-QYZBSNDTZ",
                    ajax_type: 'land',
                    children: [
                        { label: "省外企业在本省拿地投资项目", value: 998, sourceType: 'sourceProvince', type: 'land' },
                        { label: "北京企业在本省拿地投资项目", value: 11, sourceType: 'sourceProvince', type: 'land' },
                        { label: "上海企业在本省拿地投资项目", value: 31, sourceType: 'sourceProvince', type: 'land' },
                        { label: "深圳企业在本省拿地投资项目", value: 4403, sourceType: 'sourceCity', type: 'land' }]
                },
                {
                    id: 5,
                    type: 'city',
                    title: "本市企业在外地投资项目",
                    itemcode: "P-BSQYZWDTZ",
                    ajax_type: 'land',
                    children: [{ label: "本市企业在外地拿地项目", value: 0, sourceType: "sourceCity", type: 'land' }, { label: "本市上市公司在外地投资项目", value: 1, sourceType: "sourceCity", type: 'invest' }]
                },

            ],
            childrenEnterinArr: [
                { P_type: 0, type: 0, name: "全部", },
                { P_type: 1, type: 9, name: "A股上市龙头企业", },
                { P_type: 1, type: 'A090206', name: "港股中资企业", },
                { P_type: 1, type: 'A090208', name: "美股中资企业", },
                { P_type: 1, type: 1, name: "非上市龙头企业", },
                { P_type: 2, type: 2, name: "创投企业", },
                { P_type: 2, type: 3, name: "优质企业", }
            ],
            page: 1,
            order_field: 0,
            order_type: 1,
            sourceCityId: 0,
            sourceType: 'sourceCity',
            listUrl: "",//列表跳转链接
            curWebsite: this.$api.getWebsiteType(),
            page_id: 1,
            city_invest_land_type: 1,
            province_invest_land_type: 2,
            enterpriseList_city_invest: [],
            enterpriseList_province_invest: [],
            enterpriseList_city_land: [],
            enterpriseList_province_land: [],
            sm_enterprise_type: 2,
            lm_enterprise_type: 9,
            zj_enterprise_list: [],
            cx_enterprise_list: [],
            ss_enterprise_list: [],
            yq_enterprise_list: [],
        }
    },
    watch: {
        searchtype: {
            handler(newValue, oldValue) {
                console.log(newValue, oldValue);
                switch (newValue) {
                    case 1:
                        this.placeholder = '请输入企业名称';
                        break;
                    case 2:
                        this.placeholder = '请输入要搜索的产业链';
                        break;
                    case 3:
                        this.placeholder = '请输入报告名称';
                        break;
                    default:
                        this.placeholder = '请输入内容';
                }
            }
        }
    },
    created() {
        document.title = this.curWebsite.shortname + ' - 首页';
        this.userdata = this.getuseriformation();
        this.ajaxurlData.land = this.$api.enterpriseapi.land.list();
        this.ajaxurlData.invest = this.$api.investapi.investdynamic.list();
        this.getCurPageList(1);

    },
    mounted() {
        this.get_enterprise_list(0, 'sm');
        this.get_enterprise_list(0, 'lm');
        this.get_enterprise_list(2, 'sm');
        this.get_enterprise_list(9, 'lm');
        this.getchainlist();
        this.getRptList(1);
    },
    methods: {
        handlerRouter(type, list) {
            switch (type) {
                case 'chain':
                    if (list.chainId) {
                        this.routerlinkid('/chain', list.chainId);
                    }
                    break;
                case 'rpt':
                    if (this.userdata.token) {
                        window.open(list.url + '&token=' + this.userdata.token);
                    } else {
                        this.routerblank('/reportDetail?id=' + list.id);
                    }
                    break;
            }
        },
        handler_enterprise_type(type, label) {
            if (label == 'sm') {
                this.sm_enterprise_type = type;
            } else if (label == 'lm') {
                this.lm_enterprise_type = type;
            }
        },
        get_enterprise_list(type, label) {
            if (label == 'sm') {
                if (type == 0) {
                    this.ajaxsearchcompany(1, type, 'A080101');
                } else {
                    this.ajaxsearchcompany(1, type);
                }
            } else if (label == 'lm') {
                if (type == 0) {
                    this.ajaxsearchcompany(1, type, 'A020131');
                } else {
                    this.ajaxsearchcompany(1, type);
                }
            }
        },
        //获取企业列表
        ajaxsearchcompany(pages, searchtype, tag) {
            console.log('搜索企业', pages, searchtype, tag);
            this.bus.$emit('loading', true);
            var _this = this;
            let tagaja = this.splicing('tag', tag);
            var ajaxurl = this.$api.cyl.enterprise.list() + '?type=' + searchtype + tagaja;
            // console.log(ajaxurl)
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                console.log('企业列表', ajaxurl, res.data);
                if (res.data.success) {
                    var dataenterlist = res.data.list;
                    for (var i = 0; i < res.data.list.length; i++) {
                        dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode, 'notionsort');
                        dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);
                    }
                    if (searchtype == 9) {
                        _this.ss_enterprise_list = dataenterlist;
                    } else if (searchtype == 0 && tag == 'A020131') {
                        _this.yq_enterprise_list = dataenterlist;
                    } else if (searchtype == 2) {
                        _this.cx_enterprise_list = dataenterlist;
                    } else if (searchtype == 0 && tag == 'A080101') {
                        _this.zj_enterprise_list = dataenterlist;
                    }
                    console.log('企业列表', _this.ss_enterprise_list, _this.yq_enterprise_list, _this.cx_enterprise_list, _this.zj_enterprise_list);
                    _this.bus.$emit('loading', false);

                }
            }).catch(function (error) { });
            // console.log(datas);  
        },
        //投资动态跳转到投资项目库页面
        openProjectLink(url) {
            if (url && url != '') {
                window.open(url); //研究报告库外部跳转
            }
        },
        //获取用户当前选中的列表
        getCurPageList(id) {
            var arry = this.page_list.filter(list => {
                return list.id == id;
            })
            this.cur_list = arry[0];
            this.page_id = this.cur_list.id;
            this.page = 1;
            this.land_invest_type = this.cur_list.ajax_type;
            this.ajaxurl = this.ajaxurlData[this.cur_list.ajax_type];
            this.sourceType = 'sourceProvince';
            this.sourceCityId = this.cur_list.children[0].value;
            console.log('13313213123', this.cur_list, this.sourceType, this.sourceCityId);
            this.getdynamiclist();
        },
        //获取动态列表
        getdynamiclist(page) {

            this.bus.$emit('loading', true);
            var that = this;
            this.order_type = this.land_invest_type == 'invest' ? 0 : 1;
            var orderFieldJa = this.splicing('orderField', this.order_field);
            var orderTypeJa = this.splicing('orderType', this.order_type);
            var sourceCityJa = this.splicing(this.sourceType, this.sourceCityId);
            var userCityja = this.splicing(this.cur_list.type, this.userdata[this.cur_list.type]);
            var sourceExcludeja = this.page_id == 5 ? '&sourceExclude=2' : '';
            if (this.page_id == 5) {
                var soucetype = this.userdata.currentCity.type == 'city' ? this.sourceType : 'province';
                sourceCityJa = "&" + soucetype + "=" + this.userdata.currentCity.id;
                userCityja = "";
            }
            var ajaxurl = this.ajaxurl + '?pageSize=10&page=1' + orderFieldJa + orderTypeJa + userCityja + sourceCityJa + sourceExcludeja + '&ver=1';
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                console.log('获取动态列表', ajaxurl, res.data, that.page_id);

                if (res.data.success) {
                    let list = res.data.list;

                    if (that.page_id == 1) {
                        that.enterpriseList_city_invest = res.data.list;
                        that.getCurPageList(2);
                    } else if (that.page_id == 2) {
                        that.getCurPageList(3);
                        that.enterpriseList_province_invest = res.data.list;
                    } else if (that.page_id == 3) {
                        that.getCurPageList(4);
                        that.enterpriseList_city_land = res.data.list;
                    } else if (that.page_id == 4) {
                        that.enterpriseList_province_land = res.data.list;
                    }
                    that.listUrl = res.data.extend.listUrl;
                    that.totalPage = res.data.totalPage;
                    that.total = res.data.totalRecord;
                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        //获取产业链列表
        getchainlist(type) {
            var _this = this;
            if (type == "search") {
                var ajaxurl = this.$api.cyl.chain.list() + '?kw=' + _this.kw;
            } else {
                let searchKw = this.splicing('kw', this.kw, true);
                let popupChainList = this.splicing('popupChainList', this.userdata.popupChainlist);
                var ajaxurl = this.$api.cyl.chain.list() + searchKw + popupChainList;
            }
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                if (res.data.success) {
                    console.log('产业链', res, ajaxurl);
                    _this.chainlist = res.data.list;
                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        //获取报告列表
        getRptList(pages) {
            var _this = this;
            this.page = pages ? pages : 1;
            let reportIdList = this.splicing('reportIdList', this.userdata.popupReportlist);
            var ajaxurl = this.$api.cyl.report.list() + '?page=1' + reportIdList;
            this.$axios.get(ajaxurl).then(function (res) {
                if (res.data.success) {
                    console.log('报告列表', res, ajaxurl);
                    _this.reportList = res.data.list;
                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        searchkwfun() {
            console.log('搜索', this.kw, this.searchtype);
            let searchtype = this.searchtype;
            switch (searchtype) {
                case 1:
                    this.routerblank('/totalSearch?kw=' + this.kw);
                    break;
                case 2:
                    this.routerblank('/allchain?kw=' + this.kw);
                    break;
                case 3:
                    this.routerblank('/report?kw=' + this.kw);

                default:
                    break;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.content-box .content-item {
    width: 27%;
}
</style>